<template>
    <div class="container mt-2">
        <div>
            <div class="inner-page-title mb-2 mt-4">
                Admin Controls
            </div>
            <div class="inner-panel p-3">
                <table class="table admin-controls-table">
                    <tbody>
                        <tr>
                            <td class="text-nowrap">
                                Email addresses for "Manager's Refund Alert":
                            </td>
                            <td>
                                <input
                                  type="text"
                                  :class="['form-control', errors.email1 ? 'is-invalid' : '']"
                                  @keydown.space="(event) => event.preventDefault()"
                                  v-model="alertConfig1.email"
                                  placeholder="Email" />
                            </td>
                            <td>
                                <toggle-button :width="40" :height="20" :font-size="18" v-model="alertConfig1.enabled" color="#00d35f"
                                    :sync="true" :labels="false" @change="''" />
                            </td>
                        </tr>

                        <tr>
                            <td class="text-nowrap"></td>
                            <td>
                                <input
                                  type="text"
                                  :class="['form-control', errors.email2 ? 'is-invalid' : '']"
                                  @keydown.space="(event) => event.preventDefault()"
                                  v-model="alertConfig2.email"
                                  placeholder="Email" />
                            </td>
                            <td>
                                <toggle-button :width="40" :height="20" :font-size="18" v-model="alertConfig2.enabled" color="#00d35f"
                                    :sync="true" :labels="false" @change="''" />
                            </td>
                        </tr>

                        <tr>
                            <td class="text-nowrap">
                                Enable EIN auto fulfillment:
                            </td>
                            <td>
                                <toggle-button :width="40" :height="20" :font-size="18" v-model="einAutoFulfillmentConfig.enabled" color="#00d35f"
                                    :sync="true" :labels="false" @change="''" />
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <div class="button-wrap">
                    <div class="btn-custome-rounded" @click="onClickSave()">
                        <img src="@/assets/lock.png">
                        SAVE CHANGES
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="inner-page-title mb-3 mt-4">
                Reporting CSV
            </div>

            <div class="row">
                <div class="col-6 col-sm-3">
                    <div class="form-group select-multi">
                      <label> Product </label>
                      <b-dropdown :style="{ width: '100%' }">
                        <template slot="button-content">
                          Select
                          <font-awesome-icon
                            :icon="['fa', 'caret-down']"
                          ></font-awesome-icon>
                        </template>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.any"
                            @change="handleAnyProductChange"
                          />
                          Any
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.PaymentPlan"
                            @change="handleProductChange"
                          />
                          IRS Payment Plan
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.CaliforniaPayPlan"
                            @change="handleProductChange"
                          />
                          California Pay Plan
                        </label>
                        <label class="d-block pl-4 pr-4" style="width: 250px;">
                          <input
                            type="checkbox"
                            v-model="request.query.product.NewJerseyPayPlan"
                            @change="handleProductChange"
                          />
                          New Jersey Pay Plan
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.GeorgiaPayPlan"
                            @change="handleProductChange"
                          />
                          Georgia Pay Plan
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.IllinoisPayPlan"
                            @change="handleProductChange"
                          />
                          Illinois Pay Plan
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.MichiganPayPlan"
                            @change="handleProductChange"
                          />
                          Michigan Pay Plan
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.PenaltyWaiver"
                            @change="handleProductChange"
                          />
                          Penalty Waiver
                        </label>
                        <label class="d-block pl-4 pr-4">
                          <input
                            type="checkbox"
                            v-model="request.query.product.EIN"
                            @change="handleProductChange"
                          />
                          EIN Applications
                        </label>
                        <label class="d-block pl-4 pr-4" style="width: 250px;">
                          <input
                            type="checkbox"
                            v-model="request.query.product.Form4868"
                            @change="handleProductChange"
                          />
                          Tax Return Extension
                        </label>
                      </b-dropdown>
                    </div>
                </div>

                <div class="col-6 col-sm-3">
                    <div class="form-group select-multi">
                        <label> Status </label>
                        <b-dropdown :style="{ width: '100%' }">
                            <template slot="button-content">
                              Select
                              <font-awesome-icon
                                :icon="['fa', 'caret-down']"
                              ></font-awesome-icon>
                            </template>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.any"
                                @change="handleAnyStatusChange"
                              />
                              Any
                            </label>

                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.incomplete"
                                @change="handleStatusChange"
                              />
                              Incomplete
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.cancelled"
                                @change="handleStatusChange"
                              />
                              Cancelled
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.processing"
                                @change="handleStatusChange"
                              />
                              Processing
                            </label>
                            <label class="d-block pl-4 pr-4" style="width: 200px;">
                              <input
                                type="checkbox"
                                v-model="request.query.status.awaitingSignatureService"
                                @change="handleStatusChange"
                              />
                              Awaiting Signature
                            </label>
                            <label class="d-block pl-4 pr-4" style="width: 200px;">
                              <input
                                type="checkbox"
                                v-model="request.query.status.signed"
                                @change="handleStatusChange"
                              />
                              Signed
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.onHold"
                                @change="handleStatusChange"
                              />
                              On Hold
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.failed"
                                @change="handleStatusChange"
                              />
                              Failed
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.botError"
                                @change="handleStatusChange"
                              />
                              EIN Error
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.completed"
                                @change="handleStatusChange"
                              />
                              Completed
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.chargeback"
                                @change="handleStatusChange"
                              />
                              Charge Back
                            </label>
                            <label class="d-block pl-4 pr-4">
                              <input
                                type="checkbox"
                                v-model="request.query.status.deleted"
                                @change="handleStatusChange"
                              />
                              Deleted
                            </label>
                        </b-dropdown>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6 col-sm-3">
                    <div class="form-group">
                        <label> Time Period </label>
                        <select
                            class="form-control"
                            v-model="request.query.dateRange"
                            @change="handleDataRangeChange()"
                          >
                            <option value="TODAY">Today</option>
                            <option value="YESTERDAY">Yesterday</option>
                            <option value="SEVEN_DAYS">Last 7 Days</option>
                            <option value="THIRTY_DAYS">Last 30 Days</option>
                            <option value="ONE_YEAR">Last Year</option>
                            <option value="CUSTOM">CUSTOM</option>
                        </select>
                    </div>
                </div>

                <div class="col-6 col-sm-3">
                    <div class="form-group select-date">
                        <input
                            placeholder="Select Date"
                            class="form-control"
                            id="searchDatesCSV"
                            :value="
                                formatDates(
                                  request.query.startAt,
                                  request.query.endAt
                                )
                              "
                            :disabled="request.query.dateRange !== 'CUSTOM'"
                        />
                        <span
                            id="cleardatesCSV"
                            @click="clearDates()"
                            :disabled="request.query.dateRange !== 'CUSTOM'"
                        >X</span>

                        <AirbnbStyleDatepicker
                            style="position: absolute; width: 350px; left: 15px; top: 72px;"
                            :showShortcutsMenuTrigger="false"
                            :trigger-element-id="'searchDatesCSV'"
                            :monthsToShow="1"
                            :mode="'range'"
                            :fullscreen-mobile="false"
                            :date-one="request.query.startAt"
                            :date-two="request.query.endAt"
                            @date-one-selected="
                                (val) => {
                                  request.query.startAt = val;
                                }
                              "
                            @date-two-selected="
                                (val) => {
                                  request.query.endAt = val;
                                }
                              "
                        />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6 col-sm">
                    <button class="btn btn-success" @click="downloadCSV()">
                        <font-awesome-icon icon="fa-regular fa-file-alt"/>&nbsp;Download
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AXIOS } from '../scripts/http-common';
import { SnackUtils } from "../scripts/snack-common";
import { SiteUtils } from "../scripts/site-common";
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import format from "date-fns/format";

export default {
  name: 'AdminControls',
  components: {
    Datepicker,
  },
  data() {
    return {
      refundManual1: "notifications.refund.manual",
      refundManual2: "notifications.refund.manual.secondary",
      einAutoFulfillment: "ein.fulfillment.auto",
      alertConfig1: {},
      alertConfig2: {},
      einAutoFulfillmentConfig: {},
      errors: {
        email1: false,
        email2: false
      },

      // Reporting CSV section:
      request: {
        query: {
          product: {
            any: true,
            PaymentPlan: false,
            CaliforniaPayPlan: false,
            NewJerseyPayPlan: false,
            GeorgiaPayPlan: false,
            IllinoisPayPlan: false,
            MichiganPayPlan: false,
            PenaltyWaiver: false,
            EIN: false,
            Form4868: false,
          },
          type: "ANY",

          dateRange: "THIRTY_DAYS",
          startAt: "",
          endAt: "",

          status: {
            any: true,
            incomplete: false,
            cancelled: false,
            processing: false,
            onHold: false,
            failed: false,
            chargeback: false,
            completed: false,
            awaitingSignatureService: false,
            signed: false,
            botError: false,
            deleted: false
          },

        },
      },
    }
  },
  mounted() {
    AXIOS.get(`/alerts/config/list`).then(res => {
      if (res.status == 200) {
        this.setUpConfigs(res.data);
      }
    });
  },
  methods: {
    setUpConfigs(configs) {
      this.alertConfig1 = configs.find(next => next.name === this.refundManual1);
      this.alertConfig2 = configs.find(next => next.name === this.refundManual2);
      this.einAutoFulfillmentConfig = configs.find(next => next.name === this.einAutoFulfillment);
    },

    onClickSave() {
      this.errors.email1 = false;
      this.errors.email2 = false;
      let checkEmailErrorMsg1 = SiteUtils.validateEmail(this.alertConfig1.email);
      if (checkEmailErrorMsg1) {
        this.errors.email1 = checkEmailErrorMsg1;
      }
      let checkEmailErrorMsg2 = SiteUtils.validateEmail(this.alertConfig2.email);
      if (checkEmailErrorMsg2) {
        this.errors.email2 = checkEmailErrorMsg2;
      }
      if (this.errors.email1 || this.errors.email2) {
        return;
      }

      AXIOS.put(`/alerts/config/list`, [this.alertConfig1, this.alertConfig2, this.einAutoFulfillmentConfig]).then(res => {
        if (res.status == 200) {
          this.setUpConfigs(res.data);
          alert('Updated Successfully!');
        }
      }).catch(err => {
        alert('Error occurred while updating alerts configuration');
        console.log(err);
      });
    },

    handleStatusChange() {
      this.request.query.status.any = false;
    },
    handleAnyStatusChange() {
      if (this.request.query.status.any) {
        this.request.query.status.incomplete = false;
        this.request.query.status.cancelled = false;
        this.request.query.status.processing = false;
        this.request.query.status.awaitingSignatureService = false;
        this.request.query.status.signed = false;
        this.request.query.status.onHold = false;
        this.request.query.status.failed = false;
        this.request.query.status.botError = false;
        this.request.query.status.completed = false;
        this.request.query.status.chargeback = false;
        this.request.query.status.deleted = false;
      }
    },

    downloadCSV() {
      if (this.request.query.dateRange === "TODAY") {
        this.request.query.startAt = moment().format("YYYY-MM-DD");
        this.request.query.endAt = moment().format("YYYY-MM-DD");
      } else if (this.request.query.dateRange === "YESTERDAY") {
        this.request.query.startAt = moment().subtract(1, "days").format("YYYY-MM-DD");
        this.request.query.endAt = moment().subtract(1, "days").format("YYYY-MM-DD");
      } else if (this.request.query.dateRange === "SEVEN_DAYS") {
        this.request.query.startAt = moment().subtract(7, "days").format("YYYY-MM-DD");
        this.request.query.endAt = moment().format("YYYY-MM-DD");
      } else if (this.request.query.dateRange === "THIRTY_DAYS") {
        this.request.query.startAt = moment().subtract(30, "days").format("YYYY-MM-DD");
        this.request.query.endAt = moment().format("YYYY-MM-DD");
      } else if (this.request.query.dateRange === "ONE_YEAR") {
        this.request.query.startAt = moment().subtract(1, "years").format("YYYY-MM-DD");
        this.request.query.endAt = moment().format("YYYY-MM-DD");
      }

      let statuses = [];
      if (this.request.query.status.any) {
        statuses = ["Incomplete", "Cancelled", "Processing", "On Hold", "Failed", "Charge Back",
          "Completed", "Awaiting Signature", "Signed", "Bot Error", "Deleted"];
      } else {
        if (this.request.query.status.incomplete) statuses.push("Incomplete");
        if (this.request.query.status.cancelled) statuses.push("Cancelled");
        if (this.request.query.status.processing) statuses.push("Processing");
        if (this.request.query.status.onHold) statuses.push("On Hold");
        if (this.request.query.status.failed) statuses.push("Failed");
        if (this.request.query.status.chargeback) statuses.push("Charge Back");
        if (this.request.query.status.completed) statuses.push("Completed");
        if (this.request.query.status.awaitingSignatureService) statuses.push("Awaiting Signature");
        if (this.request.query.status.signed) statuses.push("Signed");
        if (this.request.query.status.botError) statuses.push("Bot Error");
        if (this.request.query.status.deleted) statuses.push("Deleted");
      }

      let products = [];
      if (this.request.query.product.any) {
        products = ["PaymentPlan", "CaliforniaPaymentPlan", "NewJerseyPaymentPlan", "GeorgiaPaymentPlan",
          "IllinoisPaymentPlan", "MichiganPaymentPlan", "PenaltyWaiver", "EIN", "Form4868"]
      } else {
        if (this.request.query.product.PaymentPlan) products.push("PaymentPlan");
        if (this.request.query.product.CaliforniaPayPlan) products.push("CaliforniaPaymentPlan");
        if (this.request.query.product.NewJerseyPayPlan) products.push("NewJerseyPaymentPlan");
        if (this.request.query.product.GeorgiaPayPlan) products.push("GeorgiaPaymentPlan");
        if (this.request.query.product.IllinoisPayPlan) products.push("IllinoisPaymentPlan");
        if (this.request.query.product.MichiganPayPlan) products.push("MichiganPaymentPlan");
        if (this.request.query.product.PenaltyWaiver) products.push("PenaltyWaiver");
        if (this.request.query.product.EIN) products.push("EIN");
        if (this.request.query.product.Form4868) products.push("Form4868");
      }

      if (products.length === 0 || statuses.length === 0) {
        SnackUtils.warning("Please select at least one status and one product.");
        return;
      }

      let start = this.request.query.startAt;
      let end = this.request.query.endAt;
      if (!start || !end) {
        SnackUtils.warning("Please specify date range.");
        return;
      }

      let request = {
        startAt: start,
        endAt: end,

        products: products.join(","),
        statuses: statuses.join(","),
      };

      console.log("CSV download request", request);

      // TODO: add required checks for the endAt, products, statuses
      let queryParams = `startAt=${request.startAt}&endAt=${request.endAt}&products=${request.products}&statuses=${request.statuses}`;
      window.location = `/api/admin/reporting/csv?${queryParams}`;
    },

    handleProductChange() {
      this.request.query.product.any = false;
    },
    handleAnyProductChange() {
      if (this.request.query.product.any) {
        this.request.query.product.PaymentPlan = false;
        this.request.query.product.CaliforniaPayPlan = false;
        this.request.query.product.NewJerseyPayPlan = false;
        this.request.query.product.GeorgiaPayPlan = false;
        this.request.query.product.IllinoisPayPlan = false;
        this.request.query.product.MichiganPayPlan = false;
        this.request.query.product.PenaltyWaiver = false;
        this.request.query.product.EIN = false;
        this.request.query.product.Form4868 = false;
      }
    },

    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, "MM/DD/YYYY");
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, "MM/DD/YYYY");
      }
      return formattedDates;
    },
    handleDataRangeChange() {
      if (this.request.query.dateRange !== "CUSTOM") {
        this.request.query.startAt = "";
        this.request.query.endAt = "";
      }
    },
    clearDates() {
      (this.request.query.startAt = ""), (this.request.query.endAt = "");
    },

  }
}
</script>

<style>
.admin-controls-table th, td {
  font-family: "Archivo", sans-serif;
  border-top: none !important;
}

.table th {
  border-top: none;
}

table.admin-controls-table td {
  vertical-align: middle !important;
}

.button-wrap {
  text-align: right;
}

#cleardatesCSV {
  position: absolute;
  right: 5%;
  top: 12%;
  cursor: pointer;
  color: darkgrey;
}

.select-date {
  padding-right: 0;
}

.select-date #searchDatesCSV {
  margin-top: 32px;
  border-radius: 999px;
}

.select-date #cleardatesCSV {
  top: 46%;
  right: 9%;
}

.select-multi {
  padding-right: 0;
  max-width: 125px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminControls.vue